import { render, staticRenderFns } from "./PastPayments.vue?vue&type=template&id=1aedfa14&scoped=true"
import script from "./PastPayments.vue?vue&type=script&lang=js"
export * from "./PastPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aedfa14",
  null
  
)

export default component.exports